import React, { useState, useEffect } from 'react';
import InvoiceApi from '../api/InvoiceApi';
import ItemCard from '../component/items/ItemCard';
import ItemApi from '../api/ItemApi';
import ContactApi from '../api/ContactApi';
import ContactDropdown from '../component/dropdown/ContactDropdown';
import InvoiceDetails from './InvoiceDetails';
import { MdDeleteOutline } from "react-icons/md";
import { ImCancelCircle } from "react-icons/im";
import { VscAccount } from 'react-icons/vsc';

const InvoiceForm = ({ invoiceId, onSubmits, toogle }) => {
    const nonce = devsAccountingApi.nonce;
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [invoiceDetails, setInvoiceDetails] = useState(false);
    const [invoiceData, setInvoiceData] = useState("");
    const [customer, setCustomer] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [DisTotalPrice ,setDisTotalPrice] = useState(0);
    const [fetchData, setFetchingData] = useState(false);
    const [message, setMessage] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [errors, setErrors] = useState({});
    const [toggleDiscount, setToggleDis] = useState(null);
    const [totaldiscountAmount, setDiscountAmount] = useState(null);
    const liveDate = new Date().toISOString()?.split("T")[0] || null;
    const [state, setState] = useState({
        contact_id: "",
        type: "",
        invoice_no: "",
        order_no: "",
        issued_at: new Date().toISOString()?.split('T')[0] || null,
        due_at: liveDate || null,
        selected_items: "",
        amount: 0,
        discount: 0,
        discountType: "percent",
        nonce: nonce
    });
    
    useEffect(() => {
        getItem();
        getCustomer();
        getInvoiceList();
        // calculateTotalDiscountPrice();

    }, []);

    useEffect(() => {
        if (invoiceId) {
            getInvoice(invoiceId);
        }
    }, [invoiceId]);

    useEffect(()=>{
        if (state.type === 'bill') {
            setState({...state, invoice_no: state.invoice_no.replace('INV', 'BIL')})
        } else {
            setState({...state, invoice_no: state.invoice_no.replace('BIL', 'INV')});
        }
        calculateTotalPrice(selectedItems);
    }, [state.type])

    const getInvoiceList = async () => {
        let prefix = state.type === 'bill' ? 'BIL' : 'INV';
        const invoice_count = await InvoiceApi.index({count:true});
        // console.log(invoice_count);
        if (invoice_count > 0) {
            const nextInvoiceNumber = `${prefix}${parseInt(invoice_count) + 1001}`;
            // console.log(nextInvoiceNumber);
            setState(prevState => ({
                ...prevState,
                invoice_no: nextInvoiceNumber
            }));
        } else {
            setState(prevState => ({
                ...prevState,
                invoice_no: prefix + '1001'
            }));
        }
    };

    const getInvoice = async (invoiceId) => {
        setFetchingData(true);
        const res = await InvoiceApi.show(invoiceId);
        // console.log('res', res);
        setToggleDis(res.discount);
        if (res) {
            setFetchingData(false);
            setState(prevState => ({
                ...prevState,
                ...res,
                issued_at: res?.issued_at?.split(' ')[0] || null, 
                due_at: res?.due_at?.split(' ')[0] || null,
            }));
            setTotalPrice(res.amount);

            if (res.item_data) {
                const selectedItemsData = JSON.parse(res.item_data);
                setSelectedItems(selectedItemsData);
            }
        }

    };

    
    const getItem = async () => {
        setFetchingData(true);
        const res = await ItemApi.index();
        // console.log(res.data)
        if (res) {
            setItems(res.data);
            setFetchingData(false)
        }
    };
    const getCustomer = async () => {
        const res = await ContactApi.index();
        // console.log(res)
        setCustomer(res.data);
    };
    const customerOptions = customer.map(customerItem => ({
        label: customerItem.name,
        value: customerItem.id,
        
    }));
    const handleItemSelect = (selectedItemId) => {
        // Ensure the items array is valid
        const selectedItem = items?.find((item) => item.id === selectedItemId);
        if (!selectedItem) {
            console.error(`Item with id ${selectedItemId} not found.`);
            return;
        }
        let qty = 1;
        const selectedAlready = selectedItems?.find((item) => item.id === selectedItemId);
        let updatedItems;
        if (selectedAlready) {
            updatedItems = selectedItems.map((sitem) =>
                sitem.id === selectedItemId
                    ? { ...sitem, quantity: sitem.quantity + 1 }
                    : sitem
            );
        } else {
            updatedItems = [...selectedItems, { ...selectedItem, quantity: qty }];
        }
        setSelectedItems(updatedItems);
        calculateTotalPrice(updatedItems);
    };
    const handleDelete = (itemId) => {
        const updatedItems = selectedItems?.filter(item => item.id !== itemId);
        setSelectedItems(updatedItems);
        calculateTotalPrice(updatedItems); // Update total price after deletion
    };
    const handleQuantityChange = (e, itemId) => {
        const newQuantity = parseInt(e.target.value);
        const updatedItems = selectedItems.map((item) =>
            item.id === itemId ? { ...item, quantity: newQuantity } : item
        );
        setSelectedItems(updatedItems);
        calculateTotalPrice(updatedItems);
    };
    const handlePriceChange = (e, itemId) => {
        const newPrice = parseFloat(e.target.value);
        const updatedItems = selectedItems.map((item) =>
            item.id === itemId ? { ...item, sale_price: newPrice } : item
        );
        setSelectedItems(updatedItems);
        calculateTotalPrice(updatedItems);
    };
    const calculateTotalPrice = (updatedItems) => {
        let totalPrice = 0;
        updatedItems.forEach((item) => {
            if (state.type === 'bill') {
                totalPrice += item.purchase_price * item.quantity;
            } else {
                totalPrice += item.sale_price * item.quantity;
            }
        });

        // console.log('total price',totalPrice);
        setTotalPrice(totalPrice);
    };

    const calculateTotalDiscountPrice = () =>{
         // Apply discount
         let discountAmount = 0;
        //  console.log('calculateTotalDiscountPrice',state);
         if (state.discountType === 'percent') {
             discountAmount = (totalPrice * parseInt(state.discount)*0.01); 
             state.discount = discountAmount;
             const finalPrice = totalPrice - discountAmount;
            //  console.log('Dicount Amount',discountAmount);
             setDiscountAmount(discountAmount);
            setDisTotalPrice(finalPrice);
            state.discountType = "";
            // state.discount = 0;
         }
         else{
            state.discountType = "value";
            const newTotal = totalPrice - parseInt(state.discount);
             discountAmount = totalPrice - newTotal;
             setDiscountAmount(discountAmount);
            //  console.log('Dicount value',newTotal);
             setDisTotalPrice(newTotal);
             state.discountType = "";
         }
    }
    const handleChangeDiscount = (e) =>{
        const { name, value } = e.target;
        // console.log('name', name, 'value', value);
        setState({
            ...state,
            [name]: value,
        });

    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        // console.log('jim',name ,'value', value)
        setState({
            ...state,
            [name]: value,
        });
    };
    const invoiceOptions =[
        { value: 'bill', label: 'Bill' },
        { value: 'invoice', label: 'Invoice' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
    
        if (invoiceId) {
            state.id = invoiceId;
        }
        if(selectedItems.length === 0){
            // console.log('Error', selectedItems);
            setErrors({"items": 'you have to select an Item'})
            setLoading(false);
            return;
        }
        const selectedItemsData = selectedItems.map(item => item);
        // console.log('all inv selectedItemsData',selectedItemsData);
        state.selected_items = JSON.stringify(selectedItemsData);
        let formdata = new FormData();
        
        Object.keys(state).forEach((key) => {
            formdata.append(key, state[key]);
        });
        // console.log('formData',formdata);
        try {
            const res = await InvoiceApi.save(formdata);
            // console.log('inv data Response',res);
             if (!res.success){
                if (res.errors) {
                    setErrors(res.errors);
                } else {
                    setMessage(res.message);
                }
                setLoading(false);
            } else if (res && res.success) {
                setMessage(res.message);
                onSubmits();
                setLoading(false);
                setInvoiceDetails(true);
                if (customer) {
                        const cur_contact = customer.find(ct=>parseInt(ct.id) === res.data.contact_id);
                        res.data.contact_name = cur_contact.name;
                    }
                    setInvoiceData(res.data);
            } else {
                setMessage('Failed to save invoice.');
                setLoading(false);
            }
        } catch (error) {
            setMessage('An error occurred while saving the invoice.');
            setLoading(false);
        }
    };
    useEffect(() => {
        setState((prevState) => ({
            ...prevState,
            amount: totalPrice,
        }));
    }, [totalPrice]);
    const handleMessage = (msg) =>{
        setMessage(msg)
        // console.log(msg);
    }
    const filteredItems = items?.filter(item =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    
    // console.log('Message',message);

    return (
        <div> 
                    {message &&
            <div className="print:hidden bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert">
                <p className="font-bold">{message}</p>
            </div>
        }
        {!invoiceDetails ?
            !fetchData ?
                <section className="p-6 mx-auto rounded-md">
                    <form onSubmit={handleSubmit}>
                        <div className="grid sm:grid-cols-1 lg:grid-cols-2 mb-5">
                            <div className=''>
                                <div className='grid grid-cols-1'>
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-700 capitalize dark:text-white">{invoiceId ? 'Edit' : 'Add'}  {state.type || 'Invoice'} </h2>

                                    </div>
                                </div>
                                <div className="mt-4">
                                    <input
                                        type="text"
                                        placeholder="Search items..."
                                        className="appearance-none block w-11/12 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 ml-1 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="grid grid-cols-2 gap-5 mt-5">
                                    {filteredItems?.map((itemData) => (
                                        <ItemCard
                                            key={itemData.id}
                                            item={itemData}
                                            onSelect={handleItemSelect}
                                            states = {state.type}
                                        />
                                    ))}
                                </div>
                            </div>
                            <div className="bg-white rounded p-5">
                                <div className="">
                                    <label className="text-gray-700 dark:text-gray-200 font-bold text-lg" required htmlFor="type">Type</label>
                                    <ContactDropdown options={invoiceOptions} onSelectChange={handleChange} name="type" selectedValue={state.type} />
                                    {errors.type && <p className="text-red-500 text-xs mt-1">{errors.type}</p>}
                                </div>
                                <div className="my-4">
                                    <label className="text-gray-700 dark:text-gray-200 font-bold text-lg" htmlFor="">Customer</label>
                                    <ContactDropdown options={customerOptions} onSelectChange={handleChange} name="contact_id" selectedValue={state.contact_id} />
                                    {errors.contact_id && <p className="text-red-500 text-xs mt-1">{errors.contact_id}</p>}
                                </div>
                                {/* Type */}
                                
                                <div className="flex mt-2 flex-wrap -mx-3 mb-6">
                                    <div className="w-1/2 px-3 mb-6 md:mb-0">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-first-name">
                                            {state.type} Date
                                        </label>
                                        <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="issued_at" type="date" name="issued_at" value={state.issued_at} onChange={handleChange} />
                                        {errors.issued_at && <p className="text-red-500 text-xs mt-1">{errors.issued_at}</p>}
                                    </div>
                                    <div className="w-1/2 px-3">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-last-name">
                                            {state.type} Number
                                        </label>
                                        <input className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded p-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text" name="invoice_no" value={state.invoice_no} onChange={handleChange} />
                                        {errors.invoice_no && <p className="text-red-500 text-xs mt-1">{errors.invoice_no}</p>}
                                    </div>
                                    <div className="w-1/2 px-3">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-last-name">
                                            Due Date
                                        </label>
                                        <input 
                                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="due_at" type="date" 
                                        name="due_at" 
                                        value={state.due_at} 
                                        onChange={handleChange} />
                                        {errors.due_at && <p className="text-red-500 text-xs mt-1">{errors.due_at}</p>}
                                    </div>
                                    <div className="w-1/2 px-3">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-last-name">
                                            Order Number
                                        </label>
                                        <input className="appearance-none  block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text" name="order_no" value={state.order_no} onChange={handleChange} />
                                        {errors.order_no && <p className="text-red-500 text-xs mt-1">{errors.order_no}</p>}
                                    </div>
                                </div>
                                <div className="inline-block min-w-full align-middle">
                                {errors.items && <p className="text-red-500 text-xs mt-1">{errors.items}</p>}
                                    <div className="overflow-hidden">
                                        <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                                            <thead className="bg-gray-100 dark:bg-gray-700">
                                                <tr>
                                                    <th className="py-3 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                        Product Name
                                                    </th>
                                                    <th className="py-3 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                        QTY
                                                    </th>
                                                    <th className="py-3 text-xs font-medium tracking-wider text-left text-gray-700 uppercase dark:text-gray-400">
                                                        Unit Price
                                                    </th>
                                                    <th className='py-3 text-xs font-medium'>

                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                                                {selectedItems?.map((item) => item ? (
                                                    <tr key={item.id} className="hover:bg-gray-100 dark:hover:bg-gray-700">
                                                        <td className="py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                            {item.name}
                                                        </td>
                                                        <td className="py-4  text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white">
                                                            <input
                                                                className="text-center"
                                                                type="number"
                                                                value={item.quantity}
                                                                onChange={(e) => handleQuantityChange(e, item.id)}
                                                            />
                                                        </td>
                                                        <td className="py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                            <input
                                                                className="text-center"
                                                                type="number"
                                                                step="1"
                                                                value={state.type === 'bill' ? item.purchase_price : item.sale_price} //Add 
                                                                onChange={(e) => handlePriceChange(e, item.id)}
                                                            />
                                                        </td>
                                                        <td className="py-4 text-sm font-medium text-gray-900">
                                                            <MdDeleteOutline 
                                                                size={28} 
                                                                onClick={() => handleDelete(item.id)} // Call the delete function here
                                                                className="cursor-pointer hover:text-red-500" // Add hover effect for better UX
                                                            />
                                                        </td>
                                                    </tr>
                                                ) : null)}

                                                <tr className="hover:bg-gray-100 dark:hover:bg-gray-700">
                                                    <td className="py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                       Sub Total
                                                    </td>
                                                    <td className="py-4 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white"></td>
                                                    <td className="py-4 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white"></td>
                                                    {/* <td className="py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                        {totalPrice ? `$${(totalPrice).toFixed(2)}` : ''}
                                                    </td> */}
                                                    <td className="py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                        {typeof totalPrice === 'number' && !isNaN(totalPrice) ? `$${totalPrice.toFixed(0)}` : ''}
                                                    </td>
                                                </tr>
                                        
                                                {(totaldiscountAmount || toggleDiscount > 0) && (
                                                    <tr className="hover:bg-gray-100 dark:hover:bg-gray-700">
                                                        <td className="py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                        Discount
                                                        </td>
                                                        <td className="py-4 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white"></td>
                                                        <td className="py-4 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white"></td>
                                                        <td className="py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                        {totaldiscountAmount 
                                                            ? `$${totaldiscountAmount.toFixed(0)}` 
                                                            : `$${Number(toggleDiscount || '').toFixed(0)}`}
                                                        </td>
                                                    </tr>
                                                )}

                                                <tr className="hover:bg-gray-100 dark:hover:bg-gray-700">
                                                    <td className="py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                       Total
                                                    </td>
                                                    <td className="py-4 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white"></td>
                                                    <td className="py-4 text-sm font-medium text-gray-500 whitespace-nowrap dark:text-white"></td>
                                                    <td className="py-4 text-sm font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                         {DisTotalPrice ? `$${(DisTotalPrice).toFixed(0)}` : `$${(totalPrice - toggleDiscount).toFixed(0)}`}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div className="my-4">
                                            <label className="text-gray-500 dark:text-gray-200 font-medium text-lg" htmlFor="discount">Discount</label>
                                            <div className="flex items-center">
                                                <input
                                                    type="number"
                                                    name='discount'
                                                    className="appearance-none block w-5/12 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                                    onChange={handleChangeDiscount}
                                                    placeholder="Enter discount"
                                                />
                                                <select
                                                    name='discountType'
                                                    onChange={handleChangeDiscount}
                                                    className="text-center ml-2 w-4/12 appearance-none block bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                            
                                                >
                                                    <option value="percent">percent(%)</option>
                                                    <option value="value">Fixed</option>
                                                </select>
                                                <span onClick={calculateTotalDiscountPrice} className="text-center cursor-pointer ml-2 appearance-none block w-3/12 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">Apply</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='float-right mt-3'>
                                    <button type='submit' className="px-8 py-2 leading-5 text-white transition-colors duration-200 transform bg-gray-700 rounded-md hover:bg-gray-600 focus:outline-none focus:bg-gray-600 ml-auto">
                                        {loading ? 'Submitting...' : 'Submit'}
                                    </button>
                                </div>
                            </div>
                        </div>
                        </form>
                    </section>
                : <div className='m-auto'><p className='text-2xl text-bold text-center'>Loading...</p> </div>
            : <InvoiceDetails invoiceData={invoiceData} onSubmits={onSubmits} msg={handleMessage} toogle={toogle} />}
    </div>
    );
};

export default InvoiceForm;
